export default "__VITE_ASSET__pf4x8o72__"